// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  width: 100%;
  font-size: 14px;
  margin-top: 0;
}
mat-form-field .mat-mdc-text-field-wrapper {
  background-color: transparent !important;
}
mat-form-field .mat-mdc-text-field-wrapper .mdc-line-ripple::before {
  border-bottom-width: 0 !important;
}
mat-form-field .mdc-text-field--filled {
  border: none;
}

mat-select-trigger {
  padding: 0;
}

mat-select {
  font-size: 14px; /* Adjust font size */
  padding: 5px; /* Adjust padding */
  border: 1px solid #ccc; /* Add border */
  background-color: #fff !important; /* Set background color */
  width: 100%;
  margin-bottom: 0;
}

mat-option {
  font-size: 14px; /* Adjust font size */
  padding: 8px; /* Adjust padding */
}
mat-option mat-pseudo-checkbox {
  display: none;
}
mat-option .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked, mat-option .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate {
  background-color: blue !important;
}

.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

.spinner-container {
  display: flex;
  justify-content: center;
  position: relative;
  left: 50%;
  padding-top: 20px;
  transform: translate(-50%, -50%);
}

.no-more-data-message {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #7d7a78;
  font-weight: bold;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/mat-multiple-selection/mat-multiple-selection.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,eAAA;EACA,aAAA;AAAF;AACE;EACI,wCAAA;AACN;AAAI;EACE,iCAAA;AAEN;AACE;EACE,YAAA;AACJ;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,eAAA,EAAA,qBAAA;EACA,YAAA,EAAA,mBAAA;EACA,sBAAA,EAAA,eAAA;EACA,iCAAA,EAAA,yBAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA,EAAA,qBAAA;EACA,YAAA,EAAA,mBAAA;AADF;AAGE;EACE,aAAA;AADJ;AAGE;EACE,iCAAA;AADJ;;AAKA;EACE,wCAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;AAFF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AADF","sourcesContent":["\nmat-form-field {\n  width: 100%;\n  font-size: 14px;\n  margin-top: 0;\n  .mat-mdc-text-field-wrapper {\n      background-color: transparent !important;\n    .mdc-line-ripple::before {\n      border-bottom-width: 0 !important;\n    }\n  }\n  .mdc-text-field--filled{\n    border: none;\n  }\n\n}\n\nmat-select-trigger{\n  padding: 0;\n}\n\nmat-select{\n  font-size: 14px; /* Adjust font size */\n  padding: 5px; /* Adjust padding */\n  border: 1px solid #ccc; /* Add border */\n  background-color: #fff !important; /* Set background color */\n  width: 100%;\n  margin-bottom: 0;\n}\n\nmat-option{\n  font-size: 14px; /* Adjust font size */\n  padding: 8px; /* Adjust padding */\n\n  mat-pseudo-checkbox{\n    display: none;\n  }\n  .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked, .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate {\n    background-color: blue !important;\n  }\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  left: 50%;\n  padding-top: 20px;\n  transform: translate(-50%, -50%);\n}\n.no-more-data-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #7d7a78;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
